import { FC } from 'react';
import { ButtonSize, ButtonThemes, ButtonTypeProps } from './TypeProps';
import classNames from 'classnames';

import styles from './Button.module.scss';

export const Button: FC<ButtonTypeProps> = ({
  className,
  size = ButtonSize.M,
  themes = ButtonThemes.Primary,
  children,
  active,
  fullWith,
  ...props
}) => {
  return (
    <button
      {...props}
      className={classNames(
        styles.WrapperButton,
        styles[themes],
        styles[size],
        {
          [styles.active]: active,
          [styles.fullWith]: fullWith,
        },
        className,
      )}
    >
      {children}
    </button>
  );
};
